var _ellipse, _ellipse2, _ellipse3, _ellipse4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.1721,
    cy: 7.35433,
    rx: 6.19554,
    ry: 6.37776,
    stroke: "#D4001D",
    strokeWidth: 1.95422
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.1721,
    cy: 24.9793,
    rx: 6.19554,
    ry: 6.37776,
    stroke: "#D4001D",
    strokeWidth: 1.95422
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.301,
    cy: 7.35433,
    rx: 6.19554,
    ry: 6.37776,
    stroke: "#D4001D",
    strokeWidth: 1.95422
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.301,
    cy: 24.9793,
    rx: 6.19554,
    ry: 6.37776,
    stroke: "#D4001D",
    strokeWidth: 1.95422
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionIcon);
export default __webpack_public_path__ + "static/media/Action_Icon.74eff5a5fa894a6a3a4b5707bf97018c.svg";
export { ForwardRef as ReactComponent };